export const baseLocationFields = [
  'id',
  'coordinates',
  'type',
  'chessFeatures',
  'generalFeatures',
  'private',
  'favorite',
  'name',
  'address',
  'image',
  'nextGambits',
  'distance',
  'visitors',
  'isVetted',
  'timezone',
  'coverBlobHash',
  'activeChessboardCount',
  'hasPlayableBoard',
];

export const baseMarkerFields = [
  'id',
  'name',
  'address',
  'coordinates',
  'mapLocationType',
  'type',
  'favorite',
  'nextGambits',
  'distance',
  'visitorCount',
  'isVetted',
  'isSparked',
  'activeChessboardCount',
  'coverBlobHash',
];

export const publicLocationFields = [
  'id',
  'coordinates',
  'type',
  'chessFeatures',
  'generalFeatures',
  'private',
  'name',
  'address',
  'image',
  'nextGambits',
  'distance',
  'visitors',
  'timezone',
  'coverBlobHash',
  'activeChessboardCount',
];

export const detailsLocationFields = [
  'id',
  'coordinates',
  'type',
  'chessFeatures',
  'generalFeatures',
  'private',
  'favorite',
  'name',
  'address',
  'about',
  'user',
  'chessSetCount',
  'chessClockCount',
  'giantChessBoardCount',
  'giantChessPieces',
  'chessTableCount',
  'createdAt',
  'updatedAt',
  'nextGambits',
  'hostedClubs',
  'visitors',
  'handshakes',
  'pendingHandshakes',
  'isCheckedIn',
  'timezone',
  'isVetted',
  'isSparked',
  'openingHours',
  'coverBlobHash',
  'coverUpdatedAt',
];

export const adminLocationFields = [...detailsLocationFields, 'verified', 'isSparked'];

export const detailsLocationImagesFields = ['id', 'imageBlobHash', 'liked', 'numberOfLikes', 'user', 'createdAt'];

export const detailsLocationCommentsFields = ['id', 'message', 'rating', 'user', 'createdAt'];

export const locationSearchFields = [
  'id',
  'coordinates',
  'type',
  'chessFeatures',
  'generalFeatures',
  'private',
  'favorite',
  'name',
  'address',
  'image',
  'nextGambits',
  'distance',
  'visitors',
  'isVetted',
  'timezone',
  'sparkAvailabilityCount',
  'sparkIntentCount',
  'coverBlobHash',
  'coverUpdatedAt',
];
